export const Instructors = ({ instructors, table = false }) => {
    if (!instructors || instructors.length === 0) {
        return (<></>);
    }
    if (instructors.length === 1) {
        return (<>{instructors[0]}</>);
    }
    if (table) {
        const instructorsList = instructors.join(", ");
        return (<>{instructorsList}</>)
    }
    
    const firstPerson = instructors[0];
    const remainPerson = instructors.slice(1);

    return (
        <div className="flex flex-row justify-between items-end gap-1">
            {firstPerson}
            <span className="text-xs">他{remainPerson.length}名</span>
        </div>
    );
};